export default __webpack_public_path__ + "static/media/sitepoint.6fe1f668.svg";